import { useContext } from 'react';
import ApplicationContext from 'components/Application/Context';

export default function useErrorHandler() {
  const { errorHandler } = useContext(ApplicationContext);
  return errorHandler;
}
